// src/utils/adpNetsuiteColumns.js
import { PROFIT_COLORS, DDS_DRAW_COLORS, TOTAL_FEE_COLORS, DEDUCTION_COLORS } from "./columnColors";

const formatLineAmount = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return "-";
  return n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const ADP_NETSUITE_EMPTY_LINES_TEXT =
  "No transaction lines returned for this journal entry.";

// Shared base classes so every column lines up with the same padding,
// sizing and typography (mirrors the look of the Journal Entry DataTable).
const HEADER_BASE = "px-3 py-2 text-xs font-bold uppercase tracking-wider whitespace-nowrap";
const CELL_BASE = "px-3 py-2 text-[13px] whitespace-nowrap";

/**
 * Columns for ADP NetSuite transaction-line tables shown in the month/year
 * journal-entry view. Colors come from the shared `columnColors` tokens so
 * these tables stay visually consistent with the Journal Entry / Associate
 * Fee tables:
 *   account → sky (identifier)   debit  → green (money in)
 *   credit  → rose (money out)   memo   → slate/violet (detail)
 */
export const adpNetsuiteColumns = () => [
  {
    key: "account",
    header: "Account",
    width: "30%",
    headerClassName: `${HEADER_BASE} text-left ${PROFIT_COLORS.header}`,
    className: `${CELL_BASE} text-left font-medium ${PROFIT_COLORS.cell} ${PROFIT_COLORS.text}`,
    render: (line) => line.account || "-",
  },
  {
    key: "debit",
    header: "Debit",
    width: "15%",
    headerClassName: `${HEADER_BASE} text-right ${DDS_DRAW_COLORS.header}`,
    className: `${CELL_BASE} text-right tabular-nums font-semibold text-palette-emerald-primary ${DDS_DRAW_COLORS.cell}`,
    render: (line) => formatLineAmount(line.debitforeignamount),
  },
  {
    key: "credit",
    header: "Credit",
    width: "15%",
    headerClassName: `${HEADER_BASE} text-right ${TOTAL_FEE_COLORS.header}`,
    className: `${CELL_BASE} text-right tabular-nums font-semibold bg-palette-rose-soft ${TOTAL_FEE_COLORS.text}`,
    render: (line) => formatLineAmount(line.creditforeignamount),
  },
  {
    key: "memo",
    header: "Memo",
    width: "40%",
    headerClassName: `${HEADER_BASE} text-left ${DEDUCTION_COLORS.header}`,
    className: `${CELL_BASE} whitespace-normal ${DEDUCTION_COLORS.cell} ${DEDUCTION_COLORS.text}`,
    render: (line) => line.memo || "-",
  },
];
